import css from 'styled-jsx/css';

const styles = css`.news-list-layout{max-width:640px;margin:auto;padding:0 16px}.news-list-layout .list-title{margin:24px 0}.news-list-layout ul{list-style:none}.news-list-layout a{display:flex;gap:15px}.news-list-layout .news-item{margin:24px 0}`;

export default styles;